
import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import TActionForm from './forms/ActionForm.vue';
import PlumbNodeMixin from './PlumbNodeMixin';

@Component({
  name: 'PlumbNodeEditor',
  components: {
    TActionForm,
  },
})
export default class PlumbNodeEditor extends PlumbNodeMixin {
  handleAbortEdit() {
    this.selectedNode = null;
    this.$emit('close');
  }

  handleDeleteNode(node) {
    this.selectedNode = null;
    const nodeId = node.guid;
    const nodeConnectionChanged = [];
    this.value.forEach((n) => {
      const connectionIndex = n.connections.indexOf(nodeId);
      if (connectionIndex > -1) {
        const clonedNode = _.cloneDeep(n);
        clonedNode.connections[connectionIndex] = null;
        nodeConnectionChanged.push(clonedNode);
      }
    });
    const nodeConnectionChangedIds = nodeConnectionChanged.map((n) => n.guid);
    this.$emit('input', [...this.value.filter((n) => !nodeConnectionChangedIds.includes(n.guid) && n.guid !== nodeId), ...nodeConnectionChanged]);
  }

  handleChangeNode(node) {
    this.selectedNode = null;
    const newNode = _.cloneDeep(node);
    this.$emit('input', [...this.value.filter((n) => n.guid !== node.guid), newNode]);
  }
}
